import React from 'react';
import { Box, TableCell, TableRow, Typography } from '@mui/material';
import StatusBadge from './StatusBadge';
import { CopyIcon } from './icons';
import { copyIconBtnSx, monoValueStyles, primaryValueStyles } from '../css/revenueItems.styles';
import { formatDateTime, formatRevenueType } from '../utils/revenueItems.utils';

const PaymentRequestRow = ({ item, onCopyPaymentUrl }) => (
  <TableRow key={item._id} hover>
    <TableCell>
      <Box
        component="span"
        title="Copy payment link"
        onClick={() => onCopyPaymentUrl(item.memoHash)}
        sx={copyIconBtnSx}
      >
        <CopyIcon />
      </Box>
    </TableCell>
    <TableCell>
      <Typography sx={primaryValueStyles}>{formatRevenueType(item.revenueType)}</Typography>
    </TableCell>
    <TableCell>
      <Typography sx={primaryValueStyles}>
        {item.amount} {item.currency || 'USDT'}
      </Typography>
    </TableCell>
    <TableCell>
      <StatusBadge status={item.status} />
    </TableCell>
    <TableCell title={item.memoHash}>
      <Typography sx={{ ...monoValueStyles, wordBreak: 'break-all' }}>{item.memoHash || '-'}</Typography>
    </TableCell>
    <TableCell>
      <Typography sx={primaryValueStyles}>{item.externalRefId || '-'}</Typography>
    </TableCell>
    <TableCell>
      <Typography sx={primaryValueStyles}>{formatDateTime(item.createdAt)}</Typography>
    </TableCell>
    <TableCell>
      <Typography sx={primaryValueStyles}>{formatDateTime(item.expiresAt)}</Typography>
    </TableCell>
  </TableRow>
);

export default PaymentRequestRow;
